import { useTranslation } from 'react-i18next'

import { PageGroup, groupAnswersByPage } from './PageGroup'
import { CardDashboard, Flex, IllustratedMessage } from '@percent/lemonade'
import type { SubmittedInfoProps } from './SubmittedInfo.types'
import styles from './SubmittedInfo.module.scss'

export function SubmittedInfo({ organisationSubmissions }: Readonly<SubmittedInfoProps>) {
  const { t } = useTranslation()

  return (
    <Flex direction="column" data-testid="submitted-info-ctn" gap={16}>
      {organisationSubmissions.length === 0 && (
        <CardDashboard data-testid="no-submitted-info">
          <IllustratedMessage
            title={t('grants.reviews.noSubmittedInfo.title')}
            description={t('grants.reviews.noSubmittedInfo.description')}
            illustration="no-grant-candidates"
          />
        </CardDashboard>
      )}

      {organisationSubmissions.length > 0 &&
        organisationSubmissions.map(submission => (
          <CardDashboard key={submission.id} title={submission.displayName} data-testid="submitted-info-card">
            <Flex direction="column" gap={24} className={styles.submittedInfoPageWrapper}>
              {groupAnswersByPage(submission.formAnswers).map(page => (
                <PageGroup key={page.pageId} page={page} displayName={submission.displayName} />
              ))}
            </Flex>
          </CardDashboard>
        ))}
    </Flex>
  )
}
